var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaycircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "224.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 224.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M932 2225 c-285 -52 -533 -202 -702 -427 -34 -44 -77 -112 -96 -150 l-34 -68 50 -75 c71 -106 196 -258 274 -335 l66 -64 0 67 c0 269 151 517 385 631 100 49 182 68 300 67 120 0 191 -17 305 -73 115 -56 247 -187 303 -298 103 -207 103 -443 0 -650 -48 -96 -178 -230 -274 -284 -165 -91 -392 -129 -573 -95 -32 6 -59 9 -61 7 -3 -3 25 -451 29 -455 1 -1 47 -6 102 -12 245 -25 519 39 713 167 484 318 652 915 405 1431 -156 327 -456 552 -818 616 -106 18 -273 18 -374 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095 1526 c-206 -53 -286 -212 -269 -535 8 -148 11 -152 112 -175 245 -56 474 32 555 212 28 64 34 181 14 253 -52 179 -239 290 -412 245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1120 c0 -8 5 -58 10 -110 28 -264 136 -489 324 -676 50 -50 120 -110 155 -134 l64 -43 -6 109 c-4 60 -12 170 -19 245 l-11 136 -86 64 c-89 67 -277 247 -374 359 -31 36 -56 58 -57 50z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaycircle);
export default __webpack_public_path__ + "static/media/paycircle.6515b106e8278244acbf5b94415d1feb.svg";
export { ForwardRef as ReactComponent };